import { useEffect, useState } from 'react';
import axios from "axios";
import { getSession } from "../utils/session";
import './DataEntryPopup.css';
import { API_URL } from "../services/api";

// foto: vista previa opcional (la abre la cámara). Nunca sale del dispositivo.
export default function FoodEntryPopup({ onClose, onSaved, foto }) {
  const [name, setName] = useState('');
  const [calories, setCalories] = useState('');
  const [protein, setProtein] = useState('');
  const [carbs, setCarbs] = useState('');
  const [fat, setFat] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [recetas, setRecetas] = useState([]);

  // Catálogo local de recetas para sugerir nombres y calorías
  useEffect(() => {
    axios.get(`${API_URL}/recipes`).then((res) => setRecetas(res.data)).catch(() => {});
  }, []);

  const elegirNombre = (valor) => {
    setName(valor);
    const receta = recetas.find((r) => r.nombre.toLowerCase() === valor.trim().toLowerCase());
    if (receta) setCalories(String(receta.calorias));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { token } = await getSession();
      await axios.post(
        `${API_URL}/foods`,
        { name, calories, protein, carbs, fat },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setLoading(false);
      if (onSaved) onSaved();
      if (onClose) onClose();
    } catch (err) {
      setLoading(false);
      const msg = err?.response?.data?.message || err?.message || 'Error al guardar alimento';
      setError(msg);
      console.error('Error guardando alimento:', err);
      alert(msg);
    }
  };

  return (
    <div className="popup-overlay">
      <div className="popup">
        <h2>{foto ? "¿Qué estás comiendo?" : "Registrar comida"}</h2>
        {foto && (
          <img src={foto} alt="Tu comida" className="popup-foto" />
        )}
        <button className="close-button" onClick={onClose}>✖</button>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nombre del alimento</label>
            <input
              value={name}
              onChange={e => elegirNombre(e.target.value)}
              list="catalogo-recetas"
              placeholder="Escribe o elige una receta"
              required
            />
            <datalist id="catalogo-recetas">
              {recetas.map((r) => (
                <option key={r._id} value={r.nombre}>{r.calorias} kcal</option>
              ))}
            </datalist>
          </div>
          <div className="form-group">
            <label>Calorías (kcal)</label>
            <input type="number" value={calories} onChange={e => setCalories(e.target.value)} required />
          </div>
          <div className="form-group">
            <label>Proteínas (g)</label>
            <input type="number" value={protein} onChange={e => setProtein(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Carbohidratos (g)</label>
            <input type="number" value={carbs} onChange={e => setCarbs(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Grasas (g)</label>
            <input type="number" value={fat} onChange={e => setFat(e.target.value)} />
          </div>
          {error && <div className="form-error">{error}</div>}
          <button type="submit" className="submit-button" disabled={loading}>
            {loading ? 'Guardando...' : 'Guardar'}
          </button>
        </form>
      </div>
    </div>
  );
}
